<div class="container">
  <la-basic-header></la-basic-header>
  <la-basic-content>
    <ng-content></ng-content>
  </la-basic-content>
</div>
<la-basic-footer></la-basic-footer>
